var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel rmheader_settings"},[_vm._m(0),_vm._v(" "),_c('rm-select',{attrs:{"options":[
      { value: 'none', caption: 'None' },
      { value: 'features', caption: 'Features' },
      { value: 'pricing', caption: 'Pricing' },
      { value: 'examples', caption: 'Examples' },
      { value: 'learn', caption: 'Learn' } ]},model:{value:(_vm.m.activeLink),callback:function ($$v) {_vm.$set(_vm.m, "activeLink", $$v)},expression:"m.activeLink"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"param-caption"},[_c('span',[_vm._v("RM Header")])])}]

export { render, staticRenderFns }